define('gigaset_contentbridge/components/manuals',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"gigaset_contentbridge/classes/utils",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup"
], function(
	$,
	_,
	Component,
	$$,
	PopupHtml
) {
	var popupTemplate = null;

	return Component.create({
		$init: function() {
			var self = this;

			$('.giga_disclaim.giga_download').on('click', function() {
				var disclaimer = $('#giga_download_disclaimer'),
					url = $(this).data('url');

				$.magnificPopup.open({
					items: {
						src: self._renderPopup({
							body: disclaimer.html()
						}),
						type: 'inline'
					},
					callbacks: {
						open: function () {
							$('button.giga_download', this.contentContainer).on('click', function(e) {
								e.preventDefault();
								window.open(url);
							});
							$('input.giga_agree', this.contentContainer).on('change', function() {
								if ($(this).is(':checked') === true) {
									$(this).parent().next('.download').show();
								} else {
									$(this).parent().next('.download').hide();
								}
							});
						}
					}
				});
			});
		},
		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		}
	});
});
